import React, { useState } from 'react';
import { getContext } from 'recompose';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';
import { Link } from 'react-router-dom';

import ROUTES from 'config/routes';
import history from 'services/history';
import formatDate from 'helpers/formatDate';
import imgUrlToResizeUrl from 'helpers/imgUrlToResizeUrl';

const ArticlePreview = props => {
  const { article, category } = props;

  return (
    <div
      className="card-item article-preview"
      role="button"
      tabIndex="0"
      onClick={() => history.push(`${ROUTES.article}/${article.id}`)}
    >
      <div className="row">
        <div className="article-preview__image-col col">
          {/* <img src={article.image} className="article-preview__image" alt="" /> */}
          <picture>
            <source className="article-preview__image" media="(max-width: 320px)" srcSet={imgUrlToResizeUrl(article.image, 260, 260, 'resize')} />
            <source className="article-preview__image" media="(max-width: 991px)" srcSet={imgUrlToResizeUrl(article.image, 400, 400, 'resize')} />
            <source className="article-preview__image" media="(min-width: 992px)" srcSet={imgUrlToResizeUrl(article.image, 280, 270)} />
            <img srcSet={imgUrlToResizeUrl(article.image, 400, 400)} className="article-preview__image" alt="" />
          </picture>
        </div>
        <div className="article-preview__text-col col">
          <div className="card-item__field">
            <div className="card-item__name">{article.title}</div>
          </div>
          <div className="row justify-content-between">
            <div className="col-12 col-md-auto article-preview__category-col">
              <div className="card-item__field">
                <div className="card-item__field-title">Category</div>
                <div className="card-item__field-text">
                  {category && category.name}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-auto article-preview__date-col">
              <div className="card-item__field">
                <div className="card-item__field-title">
                  {formatDate(article.created_at)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ArticlePreview.propTypes = {
  withMenu: PropTypes.bool,
  isOwn: PropTypes.bool
};

ArticlePreview.defaultProps = {
  withMenu: false,
  isOwn: false
};

export default ArticlePreview;
